<template>
  <div class="ax-panel-box">
    <div class="palate_box" :style="{ 'background-color': backgroundColor }">
      <div class="plate_top clearfix" :class="{'no_border': noBorder}" v-if="!noTitle">
        {{ title }}
        <span>{{ titletip }}</span>
      </div>
      <div class="plate_content" ref="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout, clearTimeout } from "timers";

export default {
  name: "ax-panel",
  props: {
    titletip: {
      type: String,
      default: ""
    },
    title: [String],
    fold: {
      type: Boolean,
      default: true
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.exp-panel {
  margin-bottom: 10px;
  .palate_box {
    margin-bottom: 0;
    .plate_top {
      font-size: 15px;
      overflow: hidden;
      span {
        font-size: 12px;
        color: #999;
      }
    }
    .plate_content {
      padding: 0 0 0 24px;
      .van-cell__title{
        padding: 0;
      }
    }
  }
}
.palate_box {
  background-color: #fff;
  overflow: hidden;
  margin-bottom: 8px;
  .plate_top {
    line-height: 56px;
    height: 56px;
    color: $value-color;
    font-size: 17px;
    text-indent: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      font-size: 12px;
      color: #999;
    }
    border-bottom: 1px solid $border-color;
    &.no_border{
      border-bottom: none;
    }
  }
  .plate_content {
    transition: height 0.3s;
    -webkit-transition: height 0.3s;
  }
}
</style>
<style lang="scss">
.plate_content {
  .form_a {
    font-size: 16px;
    color: #4e74bb;
  }
  .van-cell {
    padding: 10px 0;
    font-size: 15px;
    .van-cell__title{
      padding-left: 16px;
    }
    .van-cell__value{
      padding-right: 16px;
    }
  }
  .van-cell:not(:last-child)::after {
    border-bottom: none;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
}
</style>
